import React, { Component } from "react";
import { default as ReactSelect } from "react-select";

const colourStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    backgroundColor: "white",
    width: "100%",
    height: "auto",
    boxShadow: "none",
    padding: "8px 0px",
    cursor: "text",
    borderRadius: "4px",
    transition: "border-color .15s ease-in-out,box-shadow .15s ease-in-out",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "white" : "white",
      color: "black",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "purple",
        color: "white",
      },
    };
  },
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: "white",
    backgroundColor: "purple",
    padding: " 5px 16px",
    borderRadius: "6px 0 0 6px",
    cursor: "pointer",
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    background: "purple",
    color: "white",
    cursor: "pointer",
    border: "2px solid purple",
    "&:hover": {
      backgroundColor: "white",
      color: "purple",
    },
    borderRadius: "0 6px 6px 0",
  }),
};

export default class MultiSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionSelected: this.getSelectedOptions(props),
    };
  }

  getSelectedOptions = (props) => {
    const selected = props.selected || [];
    const options = props.data || [];

    return selected
      .map((item) => {
        const value =
          item && typeof item === "object" ? item.value : item;

        return (
          options.find(
            (option) => String(option.value) === String(value)
          ) || (item && typeof item === "object" ? item : null)
        );
      })
      .filter(Boolean);
  };

  componentDidUpdate(prevProps) {
    const getValues = (props) =>
      (props.selected || []).map((item) =>
        String(item && typeof item === "object" ? item.value : item)
      );
    const prevSelected = getValues(prevProps);
    const nextSelected = getValues(this.props);
    const selectionChanged =
      prevSelected.join(",") !== nextSelected.join(",") ||
      prevProps.data !== this.props.data;

    if (selectionChanged) {
      this.setState({ optionSelected: this.getSelectedOptions(this.props) });
    }
  }

  handleSelect = (selected) => {
    let selectedValues = selected
      ? selected.map((item) => {
          const { value } = item;
          return value;
        })
      : [];
    this.setState({
      optionSelected: selected,
    });
    this.props.handleChange(this.props.name, selectedValues);
  };
  render() {
    return (
      <span
        className="d-inline-flex w-100"
        data-toggle="popover"
        data-trigger="focus"
        data-content="Please select account(s)"
      >
        <ReactSelect
          name={this.props.name}
          options={this.props.data}
          isMulti
          hideSelectedOptions={true}
          closeMenuOnSelect={false}
          onChange={this.handleSelect}
          allowSelectAll={true}
          styles={colourStyles}
          value={this.state.optionSelected}
          className={`form-control p-0 h-100 d-flex align-items-center custom-inputs`}
          isDisabled={this.props.isDisabled}
          placeholder={this.props.placeholder}
        />
      </span>
    );
  }
}
